import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  IInternationalStudentContactUs,
  IStrapiDocument,
} from 'src/app/interfaces/strapi';
import StrapiService from 'src/app/services/strapi.service';
import { ApiService } from 'src/app/services/api.service';
import { IInternationalStudentContactUsPayload } from 'src/app/interfaces/api';
import { NgIf, NgFor } from '@angular/common';
import { BreadcrumbsComponent } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { AuthService } from '../../../services/auth.service';
import { TooltipComponent } from '../../../shared/components/tooltip/tooltip.component';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { TooltipModalComponent } from '../../../shared/components/tooltip-modal/tooltip-modal.component';

@Component({
    selector: 'app-international-student-contact-us',
    templateUrl: './international-student-contact-us.component.html',
    styleUrls: ['./international-student-contact-us.component.scss'],
    imports: [
        BreadcrumbsComponent,
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        TooltipComponent,
        NgFor,
        ModalComponent,
        TooltipModalComponent,
    ],
})
export class InternationalStudentContactUsComponent implements OnInit {
  public contactUsData: IInternationalStudentContactUs = <
    IInternationalStudentContactUs
  >{};

  public contactUsForm!: UntypedFormGroup;

  public submitted = false;

  public showTooltipModal = false;

  public tooltipModalContent: string = '';

  public showSuccessMessage = false;

  constructor(
    private readonly strapi: StrapiService,
    private readonly formBuilder: UntypedFormBuilder,
    public readonly auth: AuthService,
    public readonly api: ApiService
  ) {}

  ngOnInit(): void {
    this.strapi.getInternationalStudentContactUs().subscribe({
      next: (contactUs: IStrapiDocument<IInternationalStudentContactUs>) => {
        this.contactUsData = contactUs.data.attributes;
      },
      error: () => {},
    });

    this.contactUsForm = this.formBuilder.group({
      reason: ['', [Validators.required.bind(this)]],
      subject: ['', [Validators.required.bind(this)]],
      message: ['', [Validators.required.bind(this)]],
    });
  }

  public submit(): void {
    this.submitted = true;

    const payload = {
      reason: String(this.contactUsForm.get('reason')!.value),
      subject: String(this.contactUsForm.get('subject')!.value),
      message: String(this.contactUsForm.get('message')!.value),
    } as IInternationalStudentContactUsPayload;

    this.api.internationalStudentContactUs(payload).subscribe({
      next: () => {
        this.showSuccessMessage = true;
      },
      error: () => {
        this.showSuccessMessage = false;
      },
    });
  }

  public get formControl(): {
    [key: string]: AbstractControl;
  } {
    return this.contactUsForm.controls;
  }

  public openTooltip(id: string) {
    this.showTooltipModal = true;

    type PageDataIndex = keyof typeof this.contactUsData;

    const currentRoute = id as PageDataIndex;
    this.tooltipModalContent = this.contactUsData[currentRoute] as string;
  }
}
